import { Component, OnInit } from "@angular/core";
import { PollsService } from "./polls.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "polls-component",
  template: require('./polls.component.html'),
  styles: [require('./polls.component.scss')]
})
export class PollsComponent implements OnInit {
  polls: any[];
  onlyActive: boolean = true;
  errorMessage: any;
  predicate: string = "created_at";
  reverse: boolean;
  projects: any[] = [{ name: "Projects" }];
  nationalities: any[] = [{ name: "Nationalities" }];
  employers: any[] = [{ name: "Employers" }];
  countries: any[] = [{ name: "Countries" }];
  projectFilter: string;
  nationalityFilter: string;
  employerFilter: string;
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;

  constructor(private service: PollsService, private router: Router) {}

  ngOnInit() {
    this.getCountries();
    this.getNationalities();
    this.getPolls().subscribe((it) => {
      this.getProjects();
      this.getEmployers();
      this.sortBy("it.created_at", "created_at");
    });
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  getPolls() {
    return this.service.getPolls().map(
      (polls) => {
        this.polls = polls;
      },
      (error) => (this.errorMessage = error)
    );
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = this.projects.concat(projects);
    });
  }

  getCountries() {
    let nations = this.service.getNationalities();
    this.countries = this.countries.concat(nations);
  }

  getNationalities() {
    let nations = this.service.getNationalities();
    this.nationalities = this.nationalities.concat(nations);
  }

  getEmployers() {
    this.service.getEmployers().subscribe((employers) => {
      this.employers = this.employers.concat(employers);
    });
  }

  getCountryNames(ids: string[]): string[] {
    return this.service.getCountryNames(ids);
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toString().toLowerCase();`
    );
  }

  showResponses(poll: any) {
    PollsService.currentPoll = poll;
    this.router.navigate(["/pollresponses"]);
  }

  editPoll(poll: any) {
    PollsService.currentPoll = poll;
    this.router.navigate(["/editpoll"]);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/polls/polls.component.ts